module.exports = __webpack_public_path__ + "static/media/warning.01206f8e.png";